import { environment } from '~env/environment';

export const ICONS_NAMES = {
  editSmall: 'edit-small',
};

export const TOP_LINKS_ONLINE_SHOP_ICON = () => `${environment.cdnBaseUrl()}/images/metrox/bi_onlineshop_active.svg`;
export const TOP_LINKS_MY_MARKET_ICON = () => `${environment.cdnBaseUrl()}/images/metrox/bi_wholesale.svg`;
export const TOP_LINKS_DELIVERY_ICON = () => `${environment.cdnBaseUrl()}/images/metrox/bi_delivery.svg`;
export const TOP_LINKS_INFO_ICON = () => `${environment.cdnBaseUrl()}/images/metrox/bi_infosservices.svg`;
